import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function TextContent() {
  return;
}